import { ACTION_ARGS, MODAL_ARGS, Metadata, pick, pickAll } from '../../../../utils/spds/metadata';
import {
  MODAL_DOCS_CTA_BLOCKS,
  assembleModalDescription,
} from '../../../../utils/spds/metadata/modal-docs';
import { ensureSafeComponent } from '@embroider/util';
import { hash } from '@ember/helper';
import ModalCta from '../shared/footer-cta.gjs';
import StandardModal from '../standard.gjs';
import Super from '../../core/base.gjs';
import styles from './basic.module.scss';

const METADATA = Metadata.define({
  description: assembleModalDescription(
    'Used contextually to promote information.',
    MODAL_DOCS_CTA_BLOCKS
  ),
  extends: [
    pick(ACTION_ARGS, [{ name: 'onClose', required: true }, 'onBeforeClose', 'onOpen']),
    pickAll(MODAL_ARGS, {
      overrides: {
        primaryBtnText: { initialValue: 'OK' },
        title: { initialValue: 'Announcement' },
      },
    }),
  ],
  name: 'Basic',
});

export default class SpdsModalAnnouncementBasic extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-announcement-basic';
  styles = styles;

  <template>
    <StandardModal
      @closeOnClickOutside={{@closeOnClickOutside}}
      @id={{this.id}}
      @onBeforeClose={{@onBeforeClose}}
      @onClose={{@onClose}}
      @onOpen={{@onOpen}}
      @variantName={{this.componentName}}
      class={{this.classes}}
      data-test-spds-modal-announcement-basic
      {{this.validateArguments}}
      ...attributes
      as |M|
    >
      {{yield
        (hash
          Header=(ensureSafeComponent M.Header title=@title)
          Body=(ensureSafeComponent M.Body)
          beforeClose=M.beforeClose
          close=M.close
        )
      }}
      <M.Footer>
        {{#if (has-block "cta")}}
          {{yield to="cta"}}
        {{else}}
          <ModalCta
            @beforeClose={{M.beforeClose}}
            @close={{M.close}}
            @primaryBtnAction={{@primaryBtnAction}}
            @primaryBtnText={{@primaryBtnText}}
            @primaryBtnDisabled={{@primaryBtnDisabled}}
            @secondaryBtnAction={{@secondaryBtnAction}}
            @secondaryBtnText={{@secondaryBtnText}}
            @secondaryBtnDisabled={{@secondaryBtnDisabled}}
          />
        {{/if}}
      </M.Footer>
    </StandardModal>
  </template>
}

export const MODAL_ANNOUNCEMENT_BASIC_METADATA = SpdsModalAnnouncementBasic.metadata;
